export const COMPANY_DESCRIPTION_MAX_LENGTH = 1000;
